import React from "react";
import {
    faBolt,
    faFeather,
    faLayerGroup,
    faMobileScreenButton,
    faPlug,
    faShieldHalved,
} from "@fortawesome/free-solid-svg-icons";
import ProductTypes from "../../components/ProductTypes";

const ConsumerTechPlastics = () => {
    const products = [
        { src: "https://res.cloudinary.com/dbirahuue/image/upload/v1759165614/PanHeadScrew_crrleo.webp", name: "Pan Head Screw" },
        { src: "https://res.cloudinary.com/dbirahuue/image/upload/v1759165597/CountersunkHead_sb9xs7.webp", name: "Countersunk Head" },
    ];

    const bannerImage = "https://res.cloudinary.com/dbirahuue/image/upload/v1759157233/ConsumerTechPlastics_kqd6sc.webp";
    const heading = "Consumer Tech & Plastics";
    const description =
        "Our Consumer Tech & Plastics fasteners are engineered to support modern electronic devices, appliances, and lightweight enclosures. They offer strength, precision, and ease of assembly, making them ideal for industries where durability meets design flexibility.";

    const benefits = [
        { icon: faFeather, text: "Perfect for plastic & composite materials" },
        { icon: faShieldHalved, text: "Long-lasting in daily use applications" },
        { icon: faMobileScreenButton, text: "Designed for sleek consumer products" },
        { icon: faBolt, text: "Reduces manufacturing time" },
        { icon: faPlug, text: "Ideal for electronic enclosures" },
        { icon: faLayerGroup, text: "Compatible with automotive, electronics & appliances" },
    ];

    return (
        <ProductTypes
            products={products}
            image={bannerImage}
            heading={heading}
            description={description}
            benefits={benefits}
        />
    );
};

export default ConsumerTechPlastics;
